<script>
  export let className = "container-fluid";
</script>

<div class={className}>
  <slot />
</div>
